// De keuzelijst is een gewone <select>; de browser geeft niet door wanneer zijn lijst open is. Een muisklik opent hem, de volgende klik, een keuze, Escape of de focus kwijtraken sluit hem.
// Het is vooral mousedown: Chrome stuurt bij het openen van de lijst geen click, Firefox wel (direct na mousedown, dat negeren we). Een click zonder mousedown (bijvoorbeeld een test of een hulpmiddel) telt ook.
// Dit zet is-open op .pk-select, zodat het pijltje kan omdraaien.
const close = (select) => select.closest(".pk-select")?.classList.remove("is-open");

let pressed = false;

const toggle = (select) => select.closest(".pk-select").classList.toggle("is-open");

document.addEventListener("mousedown", (event) => {
	const select = event.target.closest(".pk-select-input");
	if (!select || event.button !== 0) return;

	pressed = true;
	toggle(select);
});

document.addEventListener("click", (event) => {
	const select = event.target.closest(".pk-select-input");
	if (!select) return;

	if (pressed) {
		pressed = false;
		return;
	}

	toggle(select);
});

document.addEventListener("change", (event) => {
	if (event.target.matches(".pk-select-input")) close(event.target);
});

document.addEventListener("focusout", (event) => {
	if (event.target.matches(".pk-select-input")) close(event.target);
});

document.addEventListener("keydown", (event) => {
	if (event.key === "Escape" && event.target.matches(".pk-select-input")) close(event.target);
});
